module.exports = __webpack_public_path__ + "static/img/s22.519ba936.png";